import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "theme-uimatch-media"
    }}>{`@theme-ui/match-media`}</h1>
    <p>{`React hooks for referencing theme-ui breakpoints.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/match-media
`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`This package provides two React hooks `}<inlineCode parentName="p">{`useResponsiveValue`}</inlineCode>{` and `}<inlineCode parentName="p">{`useBreakpointIndex`}</inlineCode>{` for referencing responsive values outside of the `}<inlineCode parentName="p">{`sx`}</inlineCode>{` prop.
Note that this is a client-side-only, JavaScript solution.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useResponsiveValue, useBreakpointIndex } from '@theme-ui/match-media'

const MyComponent = () => {
  // Return literal values:
  const color = useResponsiveValue(['red', 'green', 'blue'])
  // Or provide a function to access theme values:
  const themeColor = useResponsiveValue((theme) => [
    theme.colors.red,
    theme.colors.green,
    theme.colors.blue,
  ])
  // \`useBreakpointIndex\` returns the index of the currently matched media query:
  const index = useBreakpointIndex()

  return (
    <div>
      The current color is: {color}, and the current index is: {index}
    </div>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "server-side-rendering"
    }}>{`Server side rendering`}</h3>
    <p>{`Each hook also accepts an options object, used to set a default breakpoint index when rendering on the server.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useResponsiveValue, useBreakpointIndex } from '@theme-ui/match-media'

const MyComponent = () => {
  const color = useResponsiveValue(['red', 'green', 'blue'], {
    defaultIndex: 1,
  })
  const index = useBreakpointIndex({ defaultIndex: 0 })

  return (
    <div>
      The current color is: {color}, and the current index is: {index}
      // Gatsby will output: // The current color is: green, and the current index
      is: 0
    </div>
  )
}
`}</code></pre>
    <p>{`Each hook uses `}<inlineCode parentName="p">{`breakpoints[0]`}</inlineCode>{` by default, if not specified.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useResponsiveValue, useBreakpointIndex } from '@theme-ui/match-media'

const MyComponent = () => {
  const color = useResponsiveValue(['red', 'green', 'blue'])
  const index = useBreakpointIndex()

  return (
    <div>
      The current color is: {color}, and the current index is: {index}
      // Gatsby will output: // The current color is: red, and the current index
      is: 0
    </div>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      